import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { BdcBillingCheck } from "../../../types/bdc.type";
import { checkDetailView, sortChecks } from "./billing";

const MAX_LIST = 60;

function CheckDetail({ detail }: Readonly<{ detail: unknown }>) {
  const view = checkDetailView(detail);
  if (!view) return null;
  if (view.kind === "list") {
    const more = view.items.length - MAX_LIST;
    return (
      <Box className="mono" sx={{ mt: 0.5, wordBreak: "break-word" }}>
        {view.items.slice(0, MAX_LIST).join(", ")}
        {more > 0 && ` … และอีก ${more}`}
      </Box>
    );
  }
  if (view.kind === "pairs") {
    return (
      <Box sx={{ mt: 0.5 }}>
        {view.pairs.map(([key, value]) => (
          <div key={key}>
            <span className="sub">{key}:</span> <span className="mono">{value}</span>
          </div>
        ))}
      </Box>
    );
  }
  return (
    <Box sx={{ mt: 0.75, overflow: "auto", maxHeight: 240, bgcolor: "#fff", borderRadius: "6px" }}>
      <table className="bdc-t">
        <thead>
          <tr>
            {view.columns.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {view.rows.map((row, i) => (
            <tr key={i}>
              {view.columns.map((c) => {
                const value = row[c];
                return (
                  <td key={c} className={typeof value === "number" ? "n" : undefined}>
                    {value === null || value === undefined ? "" : typeof value === "object" ? JSON.stringify(value) : String(value)}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
}

/** The pre-issue checks: errors (block ออกใบ) first, then warnings, each with its detail. */
export default function BillingCheckList({ checks }: Readonly<{ checks: BdcBillingCheck[] }>) {
  if (checks.length === 0) {
    return <Alert severity="success">ตรวจแล้วไม่พบปัญหา</Alert>;
  }
  return (
    <Stack gap={1} data-testid="bdc-billing-checks">
      {sortChecks(checks).map((check, i) => (
        <Alert key={`${check.code}-${i}`} severity={check.level === "error" ? "error" : "warning"}>
          <AlertTitle sx={{ mb: 0 }}>{check.message}</AlertTitle>
          <CheckDetail detail={check.detail} />
        </Alert>
      ))}
    </Stack>
  );
}
